import React from 'react';
import styled from 'styled-components';
import Modal, { ModalProps } from '../../components/Modal';
const warningIcon = 'https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/warning.svg';
import Button from '../Button';
import ContainerModal from '../ContainerModal';

type ModalTimeNotAvailableProps = Pick<ModalProps, 'visible' | 'onClose'>;

const Container = styled.div`
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #555658;
  text-align: center;

  h3 {
    font-size: 24px;
    font-weight: 500;
    line-height: 32px;
    text-align: center;
    margin-top: 24px;
  }

  .info1 {
    color: #898b8e;
    font-size: 16px;
    font-weight: 500;
    line-height: 24px;
    margin-top: 24px;
  }

  @media (min-width: 900px) {
    justify-content: space-between;
  }
`;

const ModalTimeNotAvailable: React.FC<ModalTimeNotAvailableProps> = ({ visible, onClose }) => {
  return (
    <ContainerModal
      childrenFooter={<Button onClick={onClose} type="button" title="Escolher outro horário" />}
      visible={visible}
      onClose={onClose}
      headTitle=""
    >
      <Container>
        <img className="warn-image" src={warningIcon} alt="warning" />
        <h3>Horário não disponível</h3>
        <p className="info1">Desculpe. Esse horário não está mais disponível. Por favor, selecione um novo horário.</p>
      </Container>
    </ContainerModal>
  );
};

export default ModalTimeNotAvailable;
